var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgFavicon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 46,
    height: 48,
    viewBox: "0 0 46 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("polygon", {
    fill: "#2DB895",
    points: "12.424 0 1.363 9.895 33.674 14.079 45.417 3.703"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#2DB895",
    d: "M11.6503987,0.166591762 L11.8085203,0 L11.8085203,0.172999137 L11.6314241,0.172999137 L11.6503987,0.166591762 Z M11.7326219,11.9177183 L11.5681755,32.4789862 L0,42.6923426 L0.796932811,10.495281 L11.7326219,11.9177183 Z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#424242",
    points: "33.906 47.234 44.963 37.332 12.653 33.155 .908 43.524"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#424242",
    d: "M33.785583,46.6261073 L33.6088655,46.7799073 L33.6088655,46.6068822 L33.7792717,46.6068822 L33.785583,46.6261073 Z M33.7098469,34.8732168 L33.8802532,14.3088626 L45.4173858,4.08756472 L44.6284681,36.2894593 L33.7098469,34.8732168 Z"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavicon);
export default __webpack_public_path__ + "static/media/favicon.a56d0ddc1467ba465b38e1fcbd3bde4a.svg";
export { ForwardRef as ReactComponent };